import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const ScheduleMessage = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 12.75C8.34904 12.75 8.68928 12.7124 9.01689 12.6409L8.68481 13.6037C8.64209 13.7276 8.6243 13.85 8.62759 13.9676C8.42132 13.989 8.21194 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 9.19709 13.6494 10.3123 13.0453 11.2486L11.9183 10.6858C12.443 9.92189 12.75 8.9968 12.75 8C12.75 5.37665 10.6234 3.25 8 3.25C5.37665 3.25 3.25 5.37665 3.25 8C3.25 10.6234 5.37665 12.75 8 12.75Z"
        fill="currentColor"
      />
      <path
        d="M7.68481 5.09431C8.02999 5.09431 8.30981 5.37414 8.30981 5.71931V7.36446L9.52409 8.27622C9.80012 8.48348 9.85587 8.87526 9.64861 9.15129C9.44135 9.42732 9.04957 9.48306 8.77354 9.2758L7.31771 8.18268C7.29823 8.16851 7.27959 8.15325 7.2619 8.13698C7.21438 8.09341 7.17497 8.04379 7.14396 7.9902C7.09045 7.89807 7.05981 7.79101 7.05981 7.6768V5.71931C7.05981 5.37414 7.33964 5.09431 7.68481 5.09431Z"
        fill="currentColor"
      />
      <path
        d="M9.44059 11.2498C9.26399 10.7136 9.82235 10.2308 10.3274 10.483L12.6726 11.6539C13.1461 11.8903 13.1397 12.568 12.6619 12.7954L10.2929 13.9228C9.7846 14.1648 9.23622 13.6746 9.41976 13.1424L9.74931 12.1869L9.44059 11.2498Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default ScheduleMessage;
